import { MatIconModule } from '@angular/material';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastNotificationComponent } from './toast-notification.component';

@NgModule({
  declarations: [ToastNotificationComponent],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [ToastNotificationComponent]
})
export class ToastNotificationModule { }
